export const MANUAL_SESSION_CONSENT_VERSION = "manual-v1" as const;
export const JOURNAL_IMPORT_CONSENT_VERSION = "journal-import-v1" as const;
export const SENSOR_SESSION_CONSENT_VERSION = "sensor-gps-v1" as const;
export const SIMULATED_SESSION_CONSENT_VERSION = "simulation-v1" as const;
export const UNVERIFIED_SESSION_CONSENT_VERSION = "unverified-v1" as const;

export type RecordingCapture = "device-gps" | "simulation" | "unverified";
export type CompanionSessionCapture = "tracked" | "manual" | "journal-import" | "simulation" | "unverified";

/** Missing legacy metadata is never upgraded by recovery or by a new GPS fix. */
export function recordingCapture(value: unknown): RecordingCapture {
  return value === "device-gps" || value === "simulation" ? value : "unverified";
}

export function mergeRecordingCapture(...values: unknown[]): RecordingCapture {
  const captures = values.map(recordingCapture);
  if (captures.includes("simulation")) return "simulation";
  return captures.length > 0 && captures.every(value => value === "device-gps") ? "device-gps" : "unverified";
}

export function recordingConsentVersion(capture: RecordingCapture): string {
  return capture === "device-gps" ? SENSOR_SESSION_CONSENT_VERSION
    : capture === "simulation" ? SIMULATED_SESSION_CONSENT_VERSION : UNVERIFIED_SESSION_CONSENT_VERSION;
}

export function companionSessionCapture(
  consentVersion: string | null | undefined,
): CompanionSessionCapture {
  if (consentVersion === MANUAL_SESSION_CONSENT_VERSION) return "manual";
  if (consentVersion === JOURNAL_IMPORT_CONSENT_VERSION) return "journal-import";
  if (consentVersion === SIMULATED_SESSION_CONSENT_VERSION) return "simulation";
  // Known older releases did not distinguish demo feeds. Preserve their history;
  // these are recorded activity estimates, never verified timed-course evidence.
  if (consentVersion === SENSOR_SESSION_CONSENT_VERSION || consentVersion === "2026-09-v2" || consentVersion === "2026-06-v1") return "tracked";
  return "unverified";
}

export function isSensorEligibleCapture(capture: CompanionSessionCapture): boolean {
  return capture === "tracked";
}

export function captureLabel(capture: CompanionSessionCapture): string {
  return { tracked: "GPS recording", manual: "Logged manually", "journal-import": "Imported from journal", simulation: "Demo session", unverified: "Recording source unknown" }[capture];
}

export function hasRecordedTrail(capture: string): boolean {
  return capture === "tracked" || capture === "simulation" || capture === "unverified";
}
